<script>
import $ from 'jquery';
import moment from 'moment';
import {Icon} from '@iconify/vue';
import {useSidebarStore} from '@store/sidebarStore';
import store from '@store';

/* COMPOSANTS */
import AkDialog from '@components/general/AkDialog';
import AkPictureAccommodation from '@components/v2/general/AkPictureAccommodation';
import GaHelpMessage from '@components/v2/general/GaHelpMessage';
import AkLabel from '@components/v2/general/AkLabel.vue';
import AkDialogV2 from '@components/general/AkDialogV2.vue';
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import AkInputSwitch from '@components/v2/input/AkInputSwitch.vue';

/* MIXINS */
import blockadeReasonsConst from '@mixins/const/blockadeReasonsConst';
import loaderMixin from '@mixins/loaderMixin';
import permissionsMixinComputed from '@mixins/permissionsMixinComputed';
import reservationSiteConst from '@mixins/const/reservationSiteConst';
import reservationTypesConst from '@mixins/const/reservationTypesConst';
import smilyStatusConst from '@mixins/const/smilyStatusConst';
import upsellStatusConst from '@mixins/const/upsellStatusConst';
import utilsMixin from '@mixins/utilsMixin';
import {PermissionMap} from '@mixins/const/permissionConst';

/* SERVICES */
import reservationPlanningService from '@services/reservationPlanningService';
import reservationService from '@services/reservationService';
import AkDialogIcon from '../../components/general/AkDialogIcon.vue';

export default {
  components: {
    AkDialogIcon,
    AkButtonActionV2,
    AkDialogV2,
    AkDialog,
    AkPictureAccommodation,
    GaHelpMessage,
    AkLabel,
    AkInputSwitch,
    Icon,
  },
  mixins: [
    loaderMixin,
    permissionsMixinComputed,
    reservationSiteConst,
    reservationTypesConst,
    upsellStatusConst,
    blockadeReasonsConst,
    utilsMixin,
    smilyStatusConst,
  ],
  emits: ['edit-reservation'],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      reservation: undefined,
    };
  },
  methods: {
    openDeleteDialog(event) {
      this.$refs.dialogConfirmDelete.show();
      if (event) event.stopPropagation();
    },
    openCancelDialog(event) {
      this.$refs.dialogConfirmCancel.show();
      if (event) event.stopPropagation();
    },

    cancelOwnerReservation() {
      reservationPlanningService
        .cancelReservationHote(this.reservation)
        .then((data) => {
          this.callback[0](true);
        })
        .catch(() => {
          this.callback[0](false);
        })
        .finally(() => {
          this.$refs.dialogConfirmDelete.hide();
          this.close();
        });
    },
    cancelReservation() {
      this.$refs.dialogConfirmCancel.hide();
      if (this.$refs.dialogConfirmCancelValidation) {
        this.$refs.dialogConfirmCancelValidation.show();
      }
    },
    confirmCancelReservation() {
      this.$refs.dialogConfirmCancelValidation.hide();
      if (this.isOwner)
        window.open(
          `https://wkf.ms/3OKnoRp?r=use1&email_mknkmv4y=${store.state.userInformation.email}&court_texte2=${store.state.userInformation.firstName}%20${store.state.userInformation.lastName}&name=${this.reservation.localizer}`,
          '_blank',
        );
      else {
        window.open(`https://wkf.ms/3OKnoRp?r=use1&name=${this.reservation.localizer}`, '_blank');
      }
    },
    close() {
      if (!this.canAccessAccommodation(this.reservation.accommodationId)) return;
      useSidebarStore().$reset();
    },
    toggleElement(ref, event) {
      $(this.$refs[ref]).toggle();
      $(event.target).toggleClass('-rotate-90');
    },
    changeSendAutoReview() {
      reservationService.updateSendAutoReview(this.reservation.id, this.reservation.sendAutoReview);
    },
  },
  mounted() {
    reservationService.reservationSidebar(this.currentValue).then((res) => {
      this.reservation = res;
    });
  },
  computed: {
    PermissionMap() {
      return PermissionMap;
    },
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    canDisplayBoardingPass() {
      return (
        this.reservation.boardingPass && moment(this.reservation.dateEnd).add(1, 'day').startOf('day').isAfter(moment())
      );
    },
    canDeleteReservation() {
      return (
        this.callback[0] &&
        this.reservation.statusSmily === 'Unavailable' &&
        this.reservation.type === 'OWNER' &&
        moment(this.reservation.dateEnd).isAfter(moment()) &&
        (moment(this.reservation.dateStart).isAfter(moment()) || this.isGasGav)
      );
    },
    canCancelReservation() {
      return (
        this.reservation.statusSmily === 'Booked' &&
        this.reservation.type === 'GUEST' &&
        moment(this.reservation.dateStart).startOf('day').isAfter(moment().startOf('day'))
      );
    },
    isTypeGuest() {
      return this.reservation.type === 'GUEST' || this.reservation.type === 'GUEST_CANCEL';
    },
    isTypeOwner() {
      return this.reservation.type === 'OWNER' || this.reservation.type === 'OWNER_CANCEL';
    },
    period() {
      if (!this.currentValue) return '';
      let dateStart = this.currentValue.dateStart;
      let dateEnd = this.currentValue.dateEnd;

      let start = dateStart ? this.displayDate(dateStart) : '';
      let end = dateEnd ? this.displayDate(dateEnd) : '';
      return start + ' - ' + end;
    },
    status() {
      if (!this.reservation) return '';
      if (this.reservation.statusSmily === 'Unavailable') {
        if (this.reservation.type === 'OWNER') return 'Hôte';
        return 'Indisponible';
      }
      return this.displayForSmilyStatusConst(this.reservation.statusSmily);
    },
    dateCreated() {
      if (!this.reservation) return '';
      let date = this.reservation.dateCreated;
      return date ? this.displayDate(date) : '-';
    },
    dateCheckin() {
      if (!this.reservation) return '';
      let date = this.reservation.dateCheckin;
      return date ? this.displayDate(date) : '-';
    },
    dateCheckout() {
      if (!this.reservation) return '';
      let date = this.reservation.dateCheckout;
      return date ? this.displayDate(date) : '-';
    },
    hourCheckin() {
      if (!this.reservation) return '';
      let date = this.reservation.dateCheckin;
      return date ? this.displayTime(date) : '-';
    },
    hourCheckout() {
      if (!this.reservation) return '';
      let date = this.reservation.dateCheckout;
      return date ? this.displayTime(date) : '-';
    },
    isBookedOrCancelReservation() {
      return this.reservation.statusSmily !== 'Unavailable' && this.isTypeGuest;
    },
    isBookedReservation() {
      return this.reservation.statusSmily === 'Booked' && this.isTypeGuest;
    },
    isCancelReservationAccepted() {
      return this.reservation.statusSmily === 'Canceled' && this.reservation.statusRefund === 'ACCEPTED';
    },
    displayCommission() {
      let val = this.reservation.commission ? this.reservation.commission : 0;
      if (this.isSiteVga) {
        val += this.reservation.feeService ? this.reservation.feeService : 0;
      }
      return this.formatCurrency(val, this.reservation.currency);
    },
    hasUpsell() {
      return this.reservation.upsellList && this.reservation.upsellList.length > 0;
    },
    canUpdateReservation() {
      let oldHour = moment(this.reservation.dateCheckout).hour();
      let oldMin = moment(this.reservation.dateCheckout).minute();
      let checkOut = moment(this.reservation.dateEnd).hour(oldHour).minute(oldMin);
      return (
        this.callback[1] &&
        this.reservation.statusSmily === 'Unavailable' &&
        this.reservation.type === 'OWNER' &&
        moment(this.reservation.dateEnd).isAfter(moment()) &&
        (checkOut.isAfter(moment()) || this.isGasGav)
      );
    },
  },
};
</script>

<template>
  <div>
    <div v-if="reservation" class="pr-2">
      <div>
        <div class="flex justify-between">
          <div>
            <div class="font-inter text-grey-900 font-medium text-md">
              Réservation
              <router-link
                v-if="this.isGasGav"
                @click="close"
                class="font-inter text-secondary hover:text-secondary font-medium text-md"
                :to="{
                  name: 'reservationPage',
                  params: {reservationId: reservation.id},
                }">
                {{ reservation.localizer }}
              </router-link>
              <span v-else class="font-inter text-grey-900 font-medium text-md">{{ reservation.localizer }}</span>
            </div>
            <div class="font-inter text-grey-400 text-sm font-medium">le {{ dateCreated }}</div>
          </div>
          <a :href="reservation.boardingPass" target="_blank" v-if="this.canDisplayBoardingPass">
            <i class="ga-icon ga-external text-grey-900 text-2xl" />
          </a>
        </div>

        <div class="font-inter text-lg font-medium w-full text-center mt-4 text-grey-900">{{ status }}</div>
        <div class="bg-grey-50 rounded-xl justify-center items-center flex flex-col pt-4 mt-4">
          <span class="logo-site" :class="iconReservation(reservation.reservationSite)" />

          <div class="pt-4 w-full flex">
            <AkPictureAccommodation
              :id="reservation.accommodationId"
              :name="reservation.accommodationName"
              :md5="reservation.accommodationMd5"
              :physical="reservation.physical"
              :laundry="reservation.laundry"
              :disabledLink="!this.canAccessAccommodation(reservation.accommodationId)"
              @click="close"
              cover
              radius="rounded-lg"
              :height="134" />
          </div>
        </div>

        <div class="flex items-center gap-2 mt-3" v-if="isTypeGuest">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement('clientData', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Données voyageur</span>
        </div>
        <div ref="clientData" class="grid grid-cols-2 mt-4 gap-4" v-if="isTypeGuest">
          <div class="flex flex-col gap-1 col-span-2">
            <span class="font-inter font-semibold text-grey-900 text-base">Client</span>

            <router-link
              @click="close"
              v-if="this.hasPermission(PermissionMap.CLIENT.VIEW)"
              class="font-inter font-medium text-secondary hover:text-secondary text-base"
              :to="{name: 'clientPage', params: {clientId: reservation.guestId}}">
              {{ reservation.guestDisplay }}
            </router-link>
            <span class="font-inter font-medium text-grey-400 text-base" v-else>{{ reservation.guestDisplay }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Téléphone</span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ reservation.guestPhone ? reservation.guestPhone : '-' }}
            </span>
          </div>
          <div v-if="isGasGav" class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">E-mail</span>
            <span class="font-inter font-medium text-grey-400 text-base break-all whitespace-pre-wrap">
              {{ reservation.guestEmail ? reservation.guestEmail : '-' }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Adultes</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.nbAdults }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Enfants</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.nbChildren }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Bébés</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.nbBabies || 0 }}</span>
          </div>
          <div class="flex flex-col gap-1 col-span-2" v-if="!this.isOwner && reservation.comments">
            <span class="font-inter font-semibold text-grey-900 text-base">Commentaire</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.comments }}</span>
          </div>
        </div>

        <div class="flex items-center gap-2 mt-3">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement('reservationData', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Données réservation</span>
        </div>
        <div ref="reservationData" class="grid grid-cols-2 mt-4 gap-4">
          <div class="flex flex-col gap-1 col-span-2">
            <span class="font-inter font-semibold text-grey-900 text-base">Nombre de nuits</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.nbNights }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Date de check-in</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ dateCheckin }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Date de check-out</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ dateCheckout }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Heure de check-in</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ hourCheckin }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base">Heure de check-out</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ hourCheckout }}</span>
          </div>
          <div class="flex flex-col gap-1 col-span-2" v-if="this.isTypeOwner && reservation.comments">
            <span class="font-inter font-semibold text-grey-900 text-base">Commentaire hôte</span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ reservation.comments }}</span>
          </div>
          <div
            class="flex flex-col gap-1 col-span-2"
            v-if="isTypeGuest && hasPermission(PermissionMap.RESERVATION.MANAGE)">
            <AkInputSwitch
              inline
              :label="$t('reservation.sendAutoReview')"
              v-model="reservation.sendAutoReview"
              @change="changeSendAutoReview" />
          </div>
        </div>

        <div
          class="flex items-center gap-2 mt-3"
          v-if="this.reservation && this.isBookedOrCancelReservation && !this.isPartenaire">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement('montantData', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Montants</span>
        </div>
        <div
          ref="montantData"
          class="grid grid-cols-2 mt-4 gap-4"
          v-if="this.reservation && this.isBookedOrCancelReservation && !this.isPartenaire">
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.montant_total')">Montant total</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.price, reservation.currency) }}
            </span>
          </div>
          <div></div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.commission')">Commission de la plateforme</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">{{ displayCommission }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.tds')">Taxe de séjour</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.tdsAmount ? reservation.tdsAmount : 0, reservation.currency) }}
              <span class="font-inter font-medium text-grey-400 text-base" v-if="reservation.tdsAmountForAirbnb">
                ({{
                  formatCurrency(
                    reservation.tdsAmountForAirbnb ? reservation.tdsAmountForAirbnb : 0,
                    reservation.currency,
                  )
                }})
              </span>
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.cleaning')">Frais de ménage</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.feeHousework, reservation.currency) }}
            </span>
          </div>
          <div></div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.night_price')">Montant des nuits (plateforme)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.nightsPrice, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.price_by_night')">Prix moyen / nuit (plateforme)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.priceByNight, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.night_price_brut')">Montant des nuits (brut)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.priceBrut, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.price_by_night_brut')">Prix moyen / nuit (brut)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.priceBrutByNight, reservation.currency) }}
            </span>
          </div>
        </div>

        <div
          class="flex items-center gap-2 mt-3"
          v-if="
            this.reservation && (this.isBookedReservation || this.isCancelReservationAccepted) && !this.isPartenaire
          ">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement('revenuData', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Revenus et frais</span>
        </div>
        <div
          ref="revenuData"
          class="grid grid-cols-2 mt-4 gap-4"
          v-if="
            this.reservation && (this.isBookedReservation || this.isCancelReservationAccepted) && !this.isPartenaire
          ">
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.owner')">Revenu total (hôte)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.priceOwner, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.price_by_night_hote')">Prix moyen / nuit (hôte)</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.priceOwner / reservation.nbNights, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.guestadom')">Frais de gestion Guestadom</AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.guestadomGestion, reservation.currency) }}
            </span>
          </div>
          <div></div>
          <div class="flex flex-col gap-1" v-if="reservation.offer === 'OFFER1'">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.gestion_partenaire')">
                Frais de gestion concierge partenaire
              </AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.housekeeperGestion, reservation.currency) }}
            </span>
          </div>
          <div class="flex flex-col gap-1" v-if="reservation.offer === 'OFFER1'">
            <span class="font-inter font-semibold text-grey-900 text-base flex gap-2 items-center justify-between">
              <AkLabel inline :information="$t('help_amount.intendance_partenaire')">
                Frais d'intendance concierge partenaire
              </AkLabel>
            </span>
            <span class="font-inter font-medium text-grey-400 text-base">
              {{ formatCurrency(reservation.housekeeperIntendance, reservation.currency) }}
            </span>
          </div>
        </div>

        <div class="flex gap-2 justify-center mt-8" v-if="this.isGasGav || this.isOwner">
          <AkButtonActionV2
            label="Modifier cette réservation hôte"
            v-if="canUpdateReservation"
            @click="
              close();
              this.callback[1](this.reservation);
            "></AkButtonActionV2>
          <span v-if="canDeleteReservation" class="btn-action bg-red xs" @click="openDeleteDialog">
            Supprimer cette réservation hôte
          </span>
          <span v-if="canCancelReservation" class="btn-action bg-red xs" @click="openCancelDialog">
            Demander l’annulation
          </span>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col items-center gap-2 pt-4">
      <span class="spinner primary xl"></span>
      <span class="text-grey-400 font-normal font-inter">Récuperation en cours...</span>
    </div>
  </div>
  <AkDialogIcon
    ref="dialogConfirmDelete"
    :cancel-label="$t('no')"
    :title="$t('confirm_dialog')"
    :message="$t('unavailability.confirm_delete')"
    icon="text-red bg-red-50 ga-warning"
    :validate-label="$t('yes')"
    @yes="this.cancelOwnerReservation"></AkDialogIcon>
  <AkDialogIcon
    ref="dialogConfirmCancel"
    :cancel-label="$t('no')"
    :title="$t('confirm_dialog')"
    :message="$t('reservation.ask_cancel')"
    icon="text-red bg-red-50 ga-warning"
    :validate-label="$t('yes')"
    @yes="this.cancelReservation"></AkDialogIcon>

  <AkDialog
    ref="dialogConfirmCancelValidation"
    :cancel-label="$t('cancel')"
    title="Attention"
    :validate-label="$t('confirm')"
    width="600px"
    @validate="this.confirmCancelReservation">
    <div clasts="flex items-center gap-2">
      <Icon icon="fluent:warning-20-regular" class="text-red !w-[40px]" width="40" />
      <div class="flex flex-col flex-1 gap-4">
        <span>
          En cas d'annulation, vous devrez régler les frais de gestion de Guestadom et une pénalité d'annulation selon
          votre contrat. Cela peut entraîner des frais supplémentaires sur la plateforme, un avis négatif ainsi que le
          positionnement de votre annonce.
        </span>
        <span>
          Si l'annulation intervient moins de 10 jours avant l'arrivée du voyageur, nous devrons le reloger. Si cela
          génère des coûts supplémentaires, les frais seront à votre charge.
        </span>
      </div>
    </div>
  </AkDialog>
</template>
